import {Trans} from '@lingui/macro';
import React, {ReactNode} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {BasicDialog} from '../../../components/common/dialogs/basicDialog';

/*
  Props.
*/

interface BusinessHoursDialogConfirmation {
  onConfirm: Handler;
  onCancel: Handler;
  title: ReactNode;
  body: ReactNode;
  confirmLabel: ReactNode;
}

/*
  Style.
*/

const DialogContentP = styled.p`
  line-height: 22px;
  margin: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 30px 0 0;

  & > * {
    margin: 0 5px;
  }
`;

/*
  Component.
*/

export const BusinessHoursDialogConfirmation = ({
  onConfirm,
  onCancel,
  title,
  body,
  confirmLabel,
}: BusinessHoursDialogConfirmation) => (
  <BasicDialog title={title} width={420} onRequestClose={onCancel}>
    <DialogContentP>{body}</DialogContentP>

    <ButtonGroup>
      <Button onClick={onCancel} interactionId="cancel">
        <Trans id="cancel">Cancel</Trans>
      </Button>
      <Button variant={ButtonVariantsEnum.PRIMARY} onClick={onConfirm} interactionId="confirm">
        {confirmLabel}
      </Button>
    </ButtonGroup>
  </BasicDialog>
);
